// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'download';

export const Component = () => (
  <path d='M2.546 20.657h19.908c.026 0 .046.02.046.046v1.751c0 .026-.02.046-.046.046H2.546a.046.046 0 0 1-.046-.046v-1.751c0-.026.02-.046.046-.046Zm14-8.368c.16-.238.42-.349.723-.349.574 0 .943.364.943.932 0 .25-.099.476-.279.654l-4.755 4.74-.125.09c-.299.148-.394.188-.54.188-.164 0-.33-.061-.585-.188l-.125-.09-4.754-4.739a.905.905 0 0 1-.279-.655c0-.567.369-.932.943-.932.318 0 .583.094.722.334l3.09 3.05V3.433c0-.578.393-.932.989-.932.574 0 .943.365.943.932v11.894l3.089-3.037Z' />
);

export const viewBox = '0 0 25 25';
